module.exports = global["moment"] = require("-!./moment.js");


//////////////////
// WEBPACK FOOTER
// ../node_modules/expose-loader?moment!../node_modules/moment/moment.js-exposed
// module id = 259
// module chunks = 3